import { useDataViewContext } from '@aibees/elephant/context/data-view-context';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Tooltip, useMediaQuery } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DataViewSwitcherProps as Props } from './types';

export const DataViewSwitcher = memo(({ className }: Props) => {
  const isSmall = useMediaQuery('(max-width:1250px)');

  const { viewItems: options, handleSwitchView } = useDataViewContext();

  return (
    <Styled.Wrapper
      className={classnames('DataViewSwitcher', className)}
      sx={SX.root}
      direction="row"
      alignItems="center"
      gap={1}
    >
      {options.map((i) => (
        <Tooltip
          key={i.label}
          title="Coming Soon"
          disableHoverListener={!i.comingSoon}
        >
          <Button
            variant={i.selected ? 'outlined' : 'text'}
            color={i.selected ? 'primary' : 'default'}
            onClick={() => handleSwitchView(i)}
            startIcon={<Icon name={i.icon} />}
            size="xsmall"
          >
            {i.label}
          </Button>
        </Tooltip>
      ))}
    </Styled.Wrapper>
  );
});

DataViewSwitcher.displayName = 'DataViewSwitcher';
